var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.empty,style:({ 'margin-top': _vm.top + 'rem' })},[_c('p',{class:[_vm.$style.icon, _vm.$style['icon_' + _vm.name]]}),_c('p',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }